export default function ClientLogoScroller() {
  const logos = [
    "/logos/dispatch-logo.png",
    "/logos/excommlogo.png",
    "/logos/gasxl-logo.png",
    "/logos/jeep-360.png",
    "/logos/trakesh-logo.png",
    "/logos/wannaapps-logo.png",
  ]

  return (
    <section className="py-12 overflow-hidden">

      <h2 className="h2 text-center">
        Built for review-driven local businesses
      </h2>
      <p className="lead mt-2 text-center text-muted text-sm">
        Trusted by local businesses and agencies
      </p>

      <div className="mt-6 relative w-full overflow-hidden">
        <div className="flex animate-scroll gap-16">
          {[...logos, ...logos].map((src, i) => (
            <img
              key={i}
              src={src}
              className="h-10 w-auto opacity-80 dark:invert"
              alt="Client logo"
            />
          ))}
        </div>
      </div>
    </section>
  )
}
